import { Routes } from '@angular/router';
import { MyCasesListPageComponent } from './my-cases-list-page/my-cases-list-page.component';
import { AuthGuard } from '../../guards/auth.guard';
import { IsCompletedUserDataGuard } from '../../guards/is-completed-user-data.guard';
import { MyCaseDetailsPageComponent } from './my-case-details-page/my-case-details-page.component';
import {
  MyCaseShipmentDetailsPageComponent
} from './my-case-shipment-details-page/my-case-shipment-details-page.component';
import { MyCasePaymentStatusPageComponent } from './my-case-payment-status-page/my-case-payment-status-page.component';

export const myCasesRoutes: Routes = [
  {
    component: MyCasesListPageComponent,
    path: 'moje-sprawy',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: MyCaseDetailsPageComponent,
    path: 'moje-sprawy/:caseId',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: MyCaseShipmentDetailsPageComponent,
    path: 'moje-sprawy/:caseId/pismo/:shipmentId'
  },
  {
    component: MyCasePaymentStatusPageComponent,
    path: 'moje-sprawy/:caseId/pismo/:shipmentId/status-platnosci',
  }
];
